
import React, { Component } from "react";
import { withTranslation } from 'react-i18next';
import { t } from "i18next";
import './MultiBilling.css';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, IconButton, InputAdornment, Modal, Radio, RadioGroup, Stack, TextField, Tooltip, Typography } from "@mui/material";
import ToastMsg from "../../../Components/ToastMsg/ToastMsg";
import { BillSuccessPoPUp, CommonPatientDetails } from "../../../Components/Common Components/CommonComponents";
import CommonValidation from "../../../Components/CommonFunctions/CommonValidation";
import { ImagePaths } from "../../../Utility/ImagePaths";
import CalculateIcon from '@mui/icons-material/Calculate';
import { clearCachevalue, getCachevalue, localGetItem } from "../../../Utility/Services/CacheProviderService";
import { AmountFormat, debounce } from "../../../Components/CommonFunctions/CommonFunctions";
import { Colors } from "../../../Styles/Colors";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { DateTime } from "luxon";
import Loader from '../../../Components/Loader';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import MultiOPBillingTemplate from './MultiOPBillingTemplate'
import MultiIPBillingTemplate from './MultiIPBillingTemplate'
import MultiLabBillingTemplate from './MultiLabBillingTemplate'
import MultiRadBillingTemplate from './MultiRadBillingTemplate'
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import RestAPIService from "../../../Utility/Services/RestAPIService";

class MultiBillingTempAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            infoMsg: false,
            infoMsgText: '',
            is_gst_enabled: JSON.parse(localGetItem("is_gst_enabled")),
            consultantName: null,
            consultantID: null,
            opState: {},
            ipState: {},
            labState: {},
            radiologyState: {},
            totalServiceAmount: 0,
            totalconcessionAmount: 0,
            totalPayableAmount: 0,
            ClearPopupopen: false,
            TemplateName: "",
            PatientType: "",
            BillId: null,
            ReceiptId: null,
            OPTemplateData : null,
            IPTemplateData : null,
            LabTemplateData : null,
            RadTemplateData : null,
        }
        this.debouncedUpdateChildState = debounce(this.updateChildState, 500);
    }

    componentDidMount() {
        if (this.props.history?.location?.state?.SelectedTemplateData) {
            let SelectedTemplateData = this.props.history?.location?.state?.SelectedTemplateData
            if (SelectedTemplateData?.op_data) {
                this.setState({
                    OPTemplateData: SelectedTemplateData?.op_data
                })
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (this.props.history?.location?.state?.SelectedTemplateData) {
                let SelectedTemplateData = this.props.history?.location?.state?.SelectedTemplateData
                if(this.props.history?.location?.state?.SelectedTemplateData !== this.state.SelectedTemplateData){
                    this.setState({
                        TemplateId: SelectedTemplateData?.id, 
                        TemplateName: SelectedTemplateData?.template_name ? SelectedTemplateData?.template_name : '',
                        PatientType: SelectedTemplateData?.template_type === "Outpatient" ? "op" : "ip",
                        OPTemplateData: SelectedTemplateData?.op_data ? SelectedTemplateData?.op_data : null,
                        IPTemplateData: SelectedTemplateData?.ip_data ? SelectedTemplateData?.ip_data : null,
                        LabTemplateData: SelectedTemplateData?.lab_data ? SelectedTemplateData?.lab_data : null,
                        RadTemplateData: SelectedTemplateData?.rad_data ? SelectedTemplateData?.rad_data : null
                    }) 
                }
            }
        }
    }


    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message,
            DisableBtn: false
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message,
            DisableBtn: false
        })
    }

    infoMessage = (message) => {
        this.setState({
            infoMsg: true,
            infoMsgText: message
        })
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key,
        })
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            infoMsg: false,
            infoMsgText: '',
        })
    }

    isApiLoading = (isLoading = false, from) => {
      if (from === "op") {
          this.setState({ opApiLoading: isLoading ? true : false }, () => {
              if (isLoading) {
                  this.setState({ isLoader: true })
              } else if (this.state.opApiLoading === false && this.state.ipApiLoading === false) {
                  this.setState({ isLoader: false })
              }
          })
      } else if (from === "ip") {
          this.setState({ ipApiLoading: isLoading ? true : false }, () => {
              if (isLoading) {
                  this.setState({ isLoader: true })
              } else if (this.state.opApiLoading === false && this.state.ipApiLoading === false) {
                  this.setState({ isLoader: false })
              }
          })
      }
    }

    updateChildState = (childKey, newState) => {
        this.setState(
            (prevState) => ({
                ...prevState,
                [childKey]: newState,
            }),
            () => {
                const totalServiceAmount = (+this.state.opState?.totalServiceAmount || 0) + (+this.state.ipState?.totalServiceAmount || 0) + (+this.state.labState?.netAmount || 0) + (+this.state.radiologyState?.subAmount || 0)
                const totalconcessionAmount = +(this.state.opState?.totalDiscountedAmount || 0) + (+this.state.ipState?.totalDiscountedAmount || 0) + (+this.state.labState?.discountAmount || 0) + (+this.state.radiologyState?.overAllDiscountAmt || 0)
                const totalPayableAmount = (+this.state.opState?.payableAmount || 0) + (+this.state.ipState?.payableAmount || 0) + (+this.state.labState?.totalBillAmount || 0) + (+this.state.radiologyState?.payableAmount || 0)
                this.setState({ totalServiceAmount, totalconcessionAmount, totalPayableAmount });
            }
        );
    };

    renderAmountTextFields = (label, key, Icon) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                sx={{ padding: 0, margin: 0, width: "10vw" }}
                className='eMed_CrdPop_Amount_TextFields'
                size='small'
                // disabled={this.state.forCancel}
                label={t(label)}
                autoComplete='off'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
                value={states[key]}
                onChange={(e) => {
                    let number = CommonValidation.NumberWithDot(e.target.value);
                    if ((number && +e.target.value > 0) || e.target.value === "") {
                        states[key] = e.target.value
                        this.setState({
                            states
                        }, () => {
                            if (key === "CashAmount") {
                                this.setState({
                                    CashBalanceAmount: this.state.ReceivedCashAmount === "" ? "" : +e.target.value - +this.state.ReceivedCashAmount
                                })
                            }
                            let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
                            let CardAmt = states.CardAmount === "" ? 0 : +states.CardAmount;
                            let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
                            let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
                            let ChequeAmt = states.ChequeAmount === "" ? 0 : +states.ChequeAmount;
                            if ((CashAmt + CardAmt + UPIAmt + bankTransferAmt + ChequeAmt) == +states.totalPayableAmount && this.state?.totalPayableAmount && this.state.isCredit) {
                                this.setState({
                                    isCredit: false
                                })
                            }
                        })
                    }
                }}
            />
        )
    }

    renderNumberTextFields = (label, key, Right = false) => {
        var states = this.state
        let { t } = this.props;
        return (
            <TextField
                className='eMed_CrdPop_Amount_TextFields'
                sx={{ marginLeft: Right ? "1vw" : 0, width: "10vw" }}
                inputProps={{ maxLength: 20 }}
                // disabled={this.state.forCancel}
                disabled={key === "CashBalanceAmount" || (key === "ReceivedCashAmount" ? (this.state.CashAmount === "" ? true : false) : false)}
                focused={key === "CashBalanceAmount"}
                size='small'
                label={t(label)}
                value={states[key]}
                autoComplete='off'
                onChange={(e) => {
                    let number = CommonValidation.gstnumberValidation(e.target.value);
                    let onlynumber = CommonValidation.numberOnly(e.target.value);
                    if (key === "ReceivedCashAmount") {
                        if (onlynumber || e.target.value === "") {
                            this.setState({
                                ReceivedCashAmount: e.target.value,
                                CashBalanceAmount: e.target.value === "" ? "" : +this.state.CashAmount - +e.target.value
                            })
                        }
                    }
                    else {
                        if (number || e.target.value === "") {
                            states[key] = e.target.value.toUpperCase()
                            this.setState({
                                states
                            }, () => {
                                let CashAmt = states.CashAmount === "" ? 0 : +states.CashAmount;
                                let CardAmt = states.CardAmount === "" ? 0 : +states.CardAmount;
                                let UPIAmt = states.UPIAmount === "" ? 0 : +states.UPIAmount;
                                let bankTransferAmt = states.BankTfrAmount === "" ? 0 : +states.BankTfrAmount;
                                let ChequeAmt = states.ChequeAmount === "" ? 0 : +states.ChequeAmount;
                                if ((CashAmt + CardAmt + UPIAmt + bankTransferAmt + ChequeAmt) == +states.totalPayableAmount && this.state?.totalPayableAmount && this.state.isCredit) {
                                    this.setState({
                                        isCredit: false
                                    })
                                }
                            })
                        }
                    }
                }}
            />
        )
    }

    ClearFuction() {
        this.setState({
            opState: {},
            ipState: {},
            labState: {},
            radiologyState: {},
            totalServiceAmount: 0,
            totalconcessionAmount: 0,
            totalPayableAmount: 0,
            ClearPopupopen: false,
            isCard: false,
            isCash: false,
            isUPI: false,
            isBankTranfer: false,
            isCheque: false,
            totalServiceAmount: "",
            CashAmount: "",
            ReceivedCashAmount: "",
            CashBalanceAmount: "",
            CardAmount: "",
            CardTransactionNumber: "",
            UPINumber: "",
            UPIAmount: "",
            BankTfrAmount: "",
            BankTfrNumber: "",
            ChequeNumber: "",
            ChequeAmount: "",
            UhidOrPhNumber: "",
            IPorIPNumber: "",
            PatientSearchList: [],
            LabTransmittedItems: [],
            TransmittedLabId: null,
            LabTransmittedIds: null,
            RadiologyTranmittedItems: [],
            TransmittedRadiologyId: null,
            RadiologyTransmittedIds: null,
            TemplateId: null,
        })
    }

    BillFooterLabel = (label, value) => {
        return (
            <Box sx={{ display: 'flex', width: "12dvw", justifyContent: 'space-between' }}>
                <Typography sx={{ fontSize: "0.9vw" }}>{label}</Typography>
                <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{AmountFormat(value ? value : 0)}</Typography>
            </Box>
        )
    }

    ClearDataPopup = () => {
        let isHaveBillingData = (this.state.opState?.opBillingList?.filter((list) => (list.id))?.length > 0 || this.state.ipState?.ipBillingList?.filter((list) => (list.id)).length > 0 || this.state.labState?.billSummaryList?.filter((element) => (element?.lab_test_id || element?.lab_set_id || element?.package_id)).length > 0 || this.state.radiologyState?.radBillingList?.filter((bill) => (bill?.service_id)).length > 0)
        return (
            <Dialog open={this.state.ClearPopupopen}>
                <DialogTitle sx={{ color: Colors.TableHeaderTextColor, display: 'flex', justifyContent: "space-between", alignItems: 'center' }}>
                    <Typography sx={{ fontSize: "1vw", fontWeight: 600 }}>{"Confirmation !"}</Typography>
                    <IconButton onClick={() => { this.setState({ ClearPopupopen: false }) }} marginRight={'4vw'}>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent sx={{ bgcolor: Colors.PopupBackground }}>
                    {isHaveBillingData ? "Are you sure, do you want to clear the patient and billing data ?" : "Are you sure, do you want to clear the data ?"}
                </DialogContent>
                <DialogActions id="eMed_dialog_button_div" sx={{ bgcolor: Colors.PopupBackground }}>
                    {isHaveBillingData ? <Button sx={{ textTransform: "capitalize" }} id='eMed_dialog_button' color='error' variant='outlined' onClick={() => {
                        this.setState(
                            (prevState) => ({
                                triggerSignal: !prevState.triggerSignal,
                                ClearPopupopen: false
                            }),
                            () => {
                                this.ClearFuction()
                            }
                        );
                    }}>{"Clear Billing data only"}</Button> : null}
                    <Button sx={{ textTransform: "capitalize" }} id='eMed_dialog_button' color='error' variant='outlined' onClick={() => {
                        this.setState(
                            (prevState) => ({
                                triggerSignal: !prevState.triggerSignal,
                                ClearPopupopen: false,
                                PatientDetails: null,
                                PatientType: "",
                                TemplateName: "",
                                TemplateId: null,
                            }),
                            () => {
                                this.ClearFuction()
                                if (this.props.history?.location?.state?.service_number) {
                                    this.getPatientDataSearch("", this.props.history?.location?.state?.service_number)
                                }
                            }
                        );
                    }}>{"Clear all data"}</Button>
                </DialogActions>
            </Dialog>
        )
    }

    convertTimeToDecimal(time) {
        if (time) {
            let [hours, minutes] = time?.split(':').map(Number);
            return hours * 60 + minutes;
        } else {
            return 0
        }
    }

    CalculateHourAmount(ratePerHour, changedTime, fixedTime, minTime, minAmount) {
        let fixedTimes = this.convertTimeToDecimal(fixedTime);
        let changedTimes = this.convertTimeToDecimal(changedTime);
        let minTimes = this.convertTimeToDecimal(minTime ? minTime : '00:00')
        let changeAndFixedTime = changedTimes - fixedTimes
        let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0
        let timeCalculateTime = (time === 0 && minTimes === 0) ? 0 : Math.ceil(time / minTimes) === Infinity ? 0 : Math.ceil(time / minTimes)
        let totalCost = ((+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0)))
        // let minTimeHourConvert = minTimes / 60
        // let totalCost = Math.ceil((changedTimes / fixedTimes) - minTimeHourConvert) * ratePerHour;

        return totalCost;
    }

    splitTimeTaken = (time_taken) => {
        if (time_taken && typeof time_taken === "string") {
            let timeTakenStr = time_taken?.split(':');
            let timeTaken = timeTakenStr?.length > 0 && timeTakenStr?.slice(0, 2)?.join(':');
            return timeTaken;
        }
        return time_taken;
    }

    postMultiBillingTemplate = () => {
        try {
            let { opState, ipState, labState, radiologyState } = this.state
            let OPPackageIds = []
            let OPServiceIds = []
            let IPPackageIds = []
            let IPServiceIds = []
            let IPAssortedIds = []
            let LabPackageDetails = []
            let LabGroupDetails = []
            let LabTestDetails = []
            let RadiologyDetails = []
            this.LoaderFunction(true)

            opState?.opBillingList?.forEach((item) => {
                if (item?.id) {
                    if (item?.templateId) {
                        OPPackageIds.push({ "templateId": item?.templateId, "display_name": item?.display_name })
                    } else {
                        OPServiceIds.push({ "id": item?.id, "display_name": item?.display_name })
                    }
                }
            })            
            ipState?.ipBillingList?.forEach((item) => {
                if (item?.id || item?.value?.id) {
                    if (item?.templateId) {
                        IPPackageIds.push({ "template_id": item?.templateId, "display_name": item?.display_name })
                    } else if(item?.assortedId){
                        IPAssortedIds.push({ "assorted_id": item?.assortedId, "display_name": item?.display_name })
                    } else {
                        IPServiceIds.push({ "service_id": item?.id ? item?.id : item?.value?.id ? item?.value?.id : null, "display_name": item?.display_name ? item?.display_name : item?.value?.display_name ? item?.value?.display_name : ""})
                    }
                }
            })
            labState?.billSummaryList?.forEach((item) => {
                if (item?.lab_test_id) {
                    LabTestDetails.push({ "lab_test_id": item?.lab_test_id, "test_name": item?.test_name })
                } else if (item?.lab_set_id) {
                    LabGroupDetails?.push({ "lab_set_id": item?.lab_set_id, "test_name": item?.test_name })
                } else if (item?.package_id) {
                    LabPackageDetails.push({ "lab_package_id": item?.package_id, "test_name": item?.test_name })
                }
            })
            radiologyState?.radBillingList?.forEach((item) => {
                if(item?.service_id){
                    RadiologyDetails?.push({ "rad_service_id": item?.service_id, "rad_service_name": item?.service_name})
                }
            })
            let data = {
                "id": this.state.TemplateId ? this.state.TemplateId : null,
                "template_name": this.state.TemplateName,
                "template_type": this.state.PatientType === "op" ? "Outpatient" : this.state.PatientType === "ip" ? "Inpatient" : "",
                "op_data": {
                    "package_details": OPPackageIds,
                    "service_details": OPServiceIds,
                },
                "ip_data": {
                    "ip_package_details": IPPackageIds,
                    "ip_service_details": IPServiceIds,
                    "ip_assorted_details": IPAssortedIds,
                },
                "lab_data": {
                    "laboratory_details": labState?.labDetails,
                    "package_details": LabPackageDetails,
                    "group_details": LabGroupDetails,
                    "test_details": LabTestDetails,
                },
                "rad_data": {
                    "rad_service_details": RadiologyDetails
                }
            }            
            RestAPIService.create(data, Serviceurls.FO_MULTI_BILL_TEMPLATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        this.LoaderFunction(false)
                        this.successMessage(response.data.message)
                        this.setState(
                            (prevState) => ({
                                triggerSignal: !prevState.triggerSignal,
                                ClearPopupopen: false,
                                PatientDetails: null,
                                PatientType: "",
                                TemplateName: "",
                                TemplateId: null,
                            }),
                            () => {
                                this.ClearFuction()
                                if (this.props.history?.location?.state?.service_number) {
                                    this.getPatientDataSearch("", this.props.history?.location?.state?.service_number)
                                }
                                if(this.props.history?.location?.state?.SelectedTemplateData){
                                    this.props.history.push({ pathname: '/Settings/MultiBillingTemplate/Home' })
                                }
                            }
                        );
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.message) {
                        this.errorMessage(error.response.data.message)
                    } else {
                        this.errorMessage(error.message)
                    }
                })

        } catch (e) {

        }
    }

    ValiadtionBilldata = (fromCredit = false) => {
        let { opState, ipState, labState, radiologyState } = this.state
        if(!opState?.opBillingList?.length && !ipState?.ipBillingList?.length && !labState?.billSummaryList?.length && !radiologyState?.radBillingList?.length){
            this.errorMessage("Select any one of services")
        } else {
            this.postMultiBillingTemplate()
        }
    }

    ClosePopUp() {
        this.setState({
            BillId: null,
            ReceiptId: null,
            isCreditBill: null,
            triggerSignal: !this.state.triggerSignal,
            ClearPopupopen: false,
            PatientDetails: null,
            PatientType: ""
        }, () => {
            this.ClearFuction()
            if (this.props.history?.location?.state?.service_number) {
                this.getPatientDataSearch("", this.props.history?.location?.state?.service_number)
            }
        })
    }

    render() {

        const { t } = this.props
        let states = this.state
        let FullAmountEntered = ((this.state?.CashAmount ? +this.state?.CashAmount : 0) + (this.state?.CardAmount ? +this.state?.CardAmount : 0) + (this.state?.BankTfrAmount ? +this.state?.BankTfrAmount : 0) + (this.state?.UPIAmount ? +this.state?.UPIAmount : 0) + (this.state?.ChequeAmount ? +this.state?.ChequeAmount : 0)) !== (this.state.totalPayableAmount ? +this.state.totalPayableAmount : 0)
        let isHaveBillingData = (this.state.opState?.opBillingList?.filter((list) => (list.id))?.length > 0 || this.state.ipState?.ipBillingList?.filter((list) => (list.id)).length > 0 || this.state.labState?.billSummaryList?.filter((element) => (element?.lab_test_id || element?.lab_set_id || element?.package_id)).length > 0 || this.state.radiologyState?.radBillingList?.filter((bill) => (bill?.service_id)).length > 0)

        return (
            <Box className="emed_multibill_container">
                <Box className="emed_multibill_header" sx={{ justifyContent: "space-between" }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginLeft: '0.5vw', paddingTop: '0.3vw', width: "54dvw" }}>
                        <Button startIcon={<ArrowBackIosNewIcon />} sx={{ textTransform: "capitalize", margin: "1vw" }} variant="outlined" onClick={() => {
                            this.props.history.push({ pathname: '/Settings/MultiBillingTemplate/Home', })
                        }}>Back to Template Home</Button>
                    </Box>
                    <Box sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', padding: "1vw", alignItems: 'center', justifyContent: 'center', marginLeft: '0.5vw' }}>
                        <Typography sx={{ fontSize: '0.9vw', fontWeight: 600 }}>Patient Type</Typography>
                        <Divider />
                        <FormControl sx={{ marginLeft: "1vw" }}>
                            <RadioGroup
                                value={this.state.PatientType}
                                sx={{ display: 'flex', flexDirection: 'row' }}
                                onChange={(e) => {
                                    this.setState({ PatientType: e.target.value })
                                }}
                            >
                                <FormControlLabel value="op" control={<Radio size='small' inputProps={{ 'emed_tid': `all_sessions_radio_testID` }} />} label="OP" />
                                <FormControlLabel value="ip" control={<Radio size='small' inputProps={{ 'emed_tid': `all_sessions_radio_testID` }} />} label="IP" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                    <Box sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', padding: "1vw", alignItems: 'center', justifyContent: 'center', marginLeft: '0.5vw', width: "26dvw", marginRight: "0.5vw" }}>
                        {/* <Typography sx={{ fontSize: '0.9vw', fontWeight: 600 }}>Patient Details</Typography> */}
                        {/* <Divider /> */}
                        <TextField
                            size='small'
                            label={"Template Name"}
                            sx={{ width: '22vw' }}
                            id="icd-cde"
                            placeholder='Template Name'
                            inputProps={{ maxLength: 50, emed_tid: "template_name" }}
                            variant="outlined"
                            value={this.state.TemplateName}
                            onChange={(event) => {
                                this.setState({
                                    TemplateName: event.target.value
                                })
                            }}
                        />
                    </Box>
                </Box>
                <Box className="emed_multibill_content" sx={{ height: "61dvh" }}>
                    {(this.state.PatientType === "ip") ? null :
                        <MultiOPBillingTemplate
                            triggerSignal={this.state.triggerSignal}
                            onStateChange={(newState) => this.debouncedUpdateChildState("opState", newState)}
                            isApiLoading={this.isApiLoading}
                            PatientType={this.state.PatientType}
                            OPTemplateData={this.state.OPTemplateData}
                            errorMessage={this.errorMessage}
                            successMessage={this.successMessage} />}

                    {(this.state.PatientType === "op") ? null :
                        <MultiIPBillingTemplate
                            triggerSignal={this.state.triggerSignal}
                            onStateChange={(newState) => this.debouncedUpdateChildState("ipState", newState)}
                            isApiLoading={this.isApiLoading}
                            PatientType={this.state.PatientType}
                            IPTemplateData={this.state.IPTemplateData}
                            errorMessage={this.errorMessage}
                            infoMessage={this.infoMessage}
                            successMessage={this.successMessage} />}

                    <MultiLabBillingTemplate
                        triggerSignal={this.state.triggerSignal}
                        onStateChange={(newState) => this.debouncedUpdateChildState("labState", newState)}
                        PatientType={this.state.PatientType}
                        LabTemplateData={this.state.LabTemplateData}
                        LabTransmittedItems={this.state.LabTransmittedItems}
                        TransmittedLabId={this.state.TransmittedLabId}
                        errorMessage={this.errorMessage}
                        successMessage={this.successMessage} />

                    <MultiRadBillingTemplate
                        triggerSignal={this.state.triggerSignal}
                        onStateChange={(newState) => this.debouncedUpdateChildState("radiologyState", newState)}
                        PatientType={this.state.PatientType}
                        RadTemplateData={this.state.RadTemplateData}
                        RadiologyTranmittedItems={this.state.RadiologyTranmittedItems}
                        TransmittedRadiologyId={this.state.TransmittedRadiologyId}
                        errorMessage={this.errorMessage}
                        successMessage={this.successMessage} />

                </Box>
                <Box className="emed_multibill_footer" sx={{ height: "6dvh" }}>
                    <Box sx={{ backgroundColor: 'white', display: 'flex', flexDirection: 'column', padding: "0.2vw", alignItems: 'center', justifyContent: 'space-between', marginLeft: '0.5vw', width: "92.7dvw" }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '29dvw' }}>
                            {/* {this.BillFooterLabel("Total Amount", this.state.totalServiceAmount)} */}
                            <Button sx={{ textTransform: 'capitalize' }} size='small' variant='outlined'
                                onClick={() => {
                                    this.setState(
                                        (prevState) => ({
                                            ClearPopupopen: true
                                        })
                                    );
                                }}
                            >Clear All</Button>
                            <Button
                                sx={{ textTransform: 'capitalize' }} size='small' variant='contained'
                                disabled={!this.state.TemplateName || !this.state.PatientType}
                                onClick={() => { this.setState({ DisableBtn: false }, () => { this.ValiadtionBilldata() }) }}
                            >Save Template</Button>
                        </Box>
                    </Box>
                </Box>
                {this.ClearDataPopup()}
                {this.state.isErrorMsg ?
                    <ToastMsg
                        severity={'error'}
                        msg={this.state.isErrorMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.successMsg ?
                    <ToastMsg
                        severity={'success'}
                        msg={this.state.successMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.infoMsg ?
                    <ToastMsg
                        severity={'info'}
                        msg={this.state.infoMsgText}
                        msgPop={this.msgClose.bind(this)}
                    />
                    : null}
                {this.state.BillId !== null ? <BillSuccessPoPUp MultiBilling={true} InvoiceId={this.state.BillId} Receipt_id={this.state.ReceiptId} ClosePopUp={this.ClosePopUp.bind(this)} successTxt={this.state.isCreditBill ? "Credit Added Successfully !" : "Payment Received Successfully !"} /> : null}
                <Loader loaderOpen={this.state.isLoader} />
            </Box>
        )
    }
}
export default withTranslation()(MultiBillingTempAdd);